export default __webpack_public_path__ + "static/media/remove_circle_outline_24px_outlined.b01f0f82.svg";